import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import api from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSessionFromGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setSessionFromGoogle(data.token, data.user);
        // clean URL
        window.history.replaceState({}, document.title, "/dashboard");
        toast.success(`Welcome, ${data.user.name}!`);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setSessionFromGoogle]);

  return (
    <div className="min-h-screen grid place-items-center tb-auth-bg" data-testid="auth-callback">
      <div className="tb-glass rounded-3xl px-10 py-8 flex items-center gap-4">
        <span className="h-3 w-3 rounded-full bg-violet-400 animate-pulse" />
        <span className="font-display tracking-tight text-lg">Signing you in…</span>
      </div>
    </div>
  );
}
